import {
  UPLOAD_DATA,
  UPLOAD_DATA_FAIL,
  UPLOAD_DATA_SUCCESS
} from '../constants/constants'

export const UploadDataReducer = (state, action) => {
  const { type, payload } = action
  switch (type) {
    case UPLOAD_DATA:
      return {
        ...state,
        data: payload
      }
    case UPLOAD_DATA_SUCCESS:
      return {
        ...state,
        data: payload
      }
    case UPLOAD_DATA_FAIL:
      return {
        ...state,
        data: []
      }

    default:
      return state
  }
}
